module.exports = __webpack_public_path__ + "static/media/A1.ff1ac758.jpg";